export default "__VITE_ASSET__Bc8tcGbc__"